<template>
  <!-- <container>  -->
    <div class="runmetrix_content">
      <div style=" padding-left:2rem; padding-top:1px">Runmetrix</div>
      <!-- <div>{{runmetrix.date}}---{{runmetrix.totalScore}}</div> -->
        <v-table                     
            :is-loading="loading"
            is-horizontal-resize
            style="width:100%;font-size:12px"
            :columns="tableConfig.columns"        
            :table-data="tableConfig.tableData"       
            :title-row-height ="40"
            :row-height="40"
            :border="1" >                       
          </v-table>
        <div class="mt20 mb20 bold" style="padding-top:25px">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :pageIndex ="pageIndex+1" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
        </div>
    </div>
  <!-- </container> -->
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  // Tell Vue to install the plugin.
  import Vue from "vue"
  import axios from 'axios'
  import RunmetrixService from '@/services/runmetrix'
  let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }
  //  isComplete = boolean
  export default {
    name: 'run-metrix',
    data: () => ({
      loading:false,
      pageIndex:0,
      pageTotal:null,
      pageSize:10,     
      tableConfig: {
          multipleSort: false,
          tableData: [],
          columns:  [
                    {field: "date", title:'Date',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "totalScore", title:'Total Score',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "efficiency", title:'Efficiency',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "dynamics", title:'Dynamics',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "smoothness", title:'Smoothness',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "symmetricity", title:'Symmetricity',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "stability", title:'Stability',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "impact", title:'Impact',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true},
                    {field: "cadence", title:'Cadence',  width: 140, titleAlign: 'center',columnAlign:'center',isResize:true}
                  ]
                }
    }),
    props:{
          runnerId: "",
    },
    computed: {
      ...mapGetters({
        trainer: 'Trainer/trainer'
      })
    },
    methods: {     
      ...mapActions({
        createRace: 'Race/createOne'
      }),
      getRunmetrixData(pageIndex,pageSize){
        this.loading=true
        RunmetrixService.getAllRunmetrixByRunnerId(this.runnerId,pageIndex,pageSize).then(response => {
          this.tableConfig.tableData = response.data.content
          this.pageTotal = response.data.totalElements
          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log("Error in Runmetrix API: >",error)
        })
      },
      pageChange(pageIndex){
        this.pageIndex = pageIndex-1
        this.getRunmetrixData(this.pageIndex,this.pageSize)        
      },
      pageSizeChange(pageSize){
        this.pageIndex = 0
        this.pageSize = pageSize
        this.getRunmetrixData(this.pageIndex, this.pageSize)        
      },  
       changeHandle(){
       this.pageIndex = 0
      //console.log("selectedTrainer--->",this.trainerId)
      this.getRunmetrixData(this.pageIndex, this.pageSize)   
    }

    },  
    created() {  
      console.log("runid********",this.runnerId)
      this.getRunmetrixData(this.pageIndex, this.pageSize)
    },
    components: {
    }
  }
</script>
<style>
.runmetrix_content{
  margin-top:40px;
}
.runmetrix_content tr.v-table-header-row {
    background: #423799;
    color: white;
    font-size: 12px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// RunMetrix.vue?b4382974